<template>
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49935 0.667969C5.13116 0.667969 4.83268 0.966447 4.83268 1.33464V5.33463H0.832682C0.464492 5.33463 0.166016 5.63311 0.166016 6.0013C0.166016 6.36949 0.464493 6.66797 0.832682 6.66797H4.83268V10.668C4.83268 11.0362 5.13116 11.3346 5.49935 11.3346C5.86754 11.3346 6.16602 11.0362 6.16602 10.668V6.66797H10.166C10.5342 6.66797 10.8327 6.36949 10.8327 6.0013C10.8327 5.63311 10.5342 5.33463 10.166 5.33463H6.16602V1.33464C6.16602 0.966446 5.86754 0.667969 5.49935 0.667969Z"
    />
  </svg>
</template>
